import React, {
  useState,
  useEffect,
} from 'react';

import {
  Tooltip,
} from 'web-components';

import {
  Flex,
  Text,
  icons,
} from 'web-styled';

import config from 'web-config';

import {
  onboardSteps,
  getOnboardSteps,
} from '../data';

import * as S from './styled';

type Props = {
  userSteps: string[],
  percentage: number,
  onGoal: { (id: string): void },
};

const tooltipText = [
  'Review the Manual',
  'Perform a Workout',
  'Visit the Help Center',
];

const Onboarding = ({
  userSteps,
  percentage,
  onGoal,
}: Props) => {
  const {
    steps,
    current,
  } = getOnboardSteps(userSteps);

  const [goal, setActive] = useState<string>(
    onboardSteps[current],
  );

  useEffect(() => {
    const index = steps.findIndex(s => s.name === goal.id);
    if (userSteps.includes(goal.id) && steps[index + 1]?.name) {
      setActive(
        onboardSteps[steps[index + 1].name],
      );
    }
  }, [userSteps.length]);

  return (
    <S.Onboarding>
      <Flex
        width="100%"
        column
        spacing={30}
      >
        <S.ProgressBar>
          <S.Progress
            style={{ width: `${percentage}%` }}
          />
        </S.ProgressBar>
        <Flex
          column
          spacing={10}
        >
          <Text
            size="18px"
            weight="700"
            color="#757575"
          >
            {goal.title}
          </Text>
          <Text
            size="17px"
            color="#757575"
            dangerouslySetInnerHTML={{ __html: goal.description }}
          />
        </Flex>
      </Flex>
      {goal.article && (
        <S.Article
          target="_blank"
          href={goal.link}
          rel="noopener noreferrer"
        >
          {goal.article}
        </S.Article>
      )}
      <Flex
        width="100%"
        align="center"
        justify="space-between"
      >
        {{
          review_documents: (
            <S.GoalButton
              onClick={() => {
                onGoal(goal.id);
              }}
            >
              {goal.button}
            </S.GoalButton>
          ),
          perform_workout: (
            <Flex spacing={20}>
              <S.GoalButton
                as="a"
                href={config.mobile.app_store_url}
                target="_blank"
              >
                App Store
              </S.GoalButton>
              <S.GoalButton
                as="a"
                href={config.mobile.google_play_url}
                target="_blank"
              >
                Google Play
              </S.GoalButton>
            </Flex>
          ),
          got_questions: (
            <S.GoalButton
              onClick={() => {
                onGoal(goal.id);
              }}
            >
              {goal.button}
            </S.GoalButton>
          ),
        }[goal.id]}
        <Flex
          align="center"
          spacing={15}
        >
          {steps.map((item, index) => (
            <Tooltip
              key={item.name}
              body={tooltipText[index]}
              preferPlace="above"
            >
              <S.Icon
                completed={item.isCompleted}
                activeStep={item.name === goal.id}
                onClick={() => {
                  setActive(
                    onboardSteps[item.name],
                  );
                }}
              >
                <img src={icons.check} alt="" />
                <span>
                  {index + 1}
                </span>
              </S.Icon>
            </Tooltip>
          ))}
        </Flex>
      </Flex>
    </S.Onboarding>
  );
};

export default Onboarding;
